import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'

export const fetchChangeLogs = (params = {}) => async (dispatch) => {
  dispatch({ type: ActionTypes.CHANGELOG_FETCH_LOAD })
  try {
    const result = await api.get('change-logs', params)
    dispatch({
      type: ActionTypes.CHANGELOG_FETCH_SUCCEED,
      data: result.data,
      total: result.total,
      skip: result.skip,
      limit: result.limit,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.CHANGELOG_FETCH_FAIL,
      error: error.message,
    })
  }
}

export const fetchChangeLogDetail = (id) => async (dispatch) => {
  dispatch({ type: ActionTypes.CHANGELOG_FETCH_DETAIL_LOAD })
  try {
    const result = await api.get(`change-logs/${id}`)
    dispatch({
      type: ActionTypes.CHANGELOG_FETCH_DETAIL_SUCCEED,
      detail: result,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.CHANGELOG_FETCH_DETAIL_FAIL,
      error: error.message,
    })
  }
}

